import { PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
/**
 * Pipe protecting against unallowed HTML use.
 * Merged with similar safeHtml pipe found in primeNG 17.
 */
export let SafeHtmlPipe = /*#__PURE__*/(() => {
  class SafeHtmlPipe {
    constructor(platformId, sanitizer) {
      this.platformId = platformId;
      this.sanitizer = sanitizer;
    }
    transform(content) {
      if (!content) return content;
      // this line was implemented in primeNG safeHtml pipe, not sure why.
      // we want innerHTML to render correctly on server, so it was removed.
      // if(!isPlatformBrowser(this.platformId)) return content;
      return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    static {
      this.ɵfac = function SafeHtmlPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafeHtmlPipe)(i0.ɵɵdirectiveInject(PLATFORM_ID, 16), i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "safeHtml",
        type: SafeHtmlPipe,
        pure: true
      });
    }
  }
  return SafeHtmlPipe;
})();